import React, {FunctionComponent, useCallback, useEffect, useMemo, useRef} from 'react'
import {useNavigation, useRootDispatch, useRootSelector} from '../../../../utils/hooks'
import refStyles from '../RefPage/RefPage.module.sass'
import InfiniteScroll from '../../../etc/scroll/InfiniteScroll'
import {Table} from '../../../data-components/Table/Table/Table'
import {User, UserWithDepartments} from '../../../../responses/users'
import {Column} from '../../../data-components/Table/Column'
import Field from '../../../controls/Field/Field'
import SearchIcon from 'files/search.svg'
import {usersActions} from '../../../../redux/pages/settings/users'
import {Checkbox} from '../../../controls/Checkbox/Checkbox'
import clsx from 'clsx'
import {Classes} from '../../../../styles'

import Tabs from '../../../navigation/Tabs/Tabs'
import {useRouteMatch} from 'react-router'
import {RefKey} from '../../../../responses/refs/refs'
import {ROUTES} from '../../../../http/routes'
import {NavLink} from 'react-router-dom'
import {urlWithParams} from '../../../../http/utils'
import styles from './UsersPage.module.sass'

//const RefPage = lazy(() => import('../RefPage/RefPage'))
//const DepartmentsPage = lazy(() => import('../DepartmentsPage/DepartmentsPage'))

const UsersPage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const search = useRootSelector(state => state.pages.settings.users.search)
    const data = useRootSelector(state => state.pages.settings.users.data)

    const setSearch = useCallback((search: string) => {
        dispatch(usersActions.list.init(search))
    }, [dispatch])

    useEffect(() => {
        setSearch(search)
    }, [setSearch, search])

    const listRef = useRef(null)
    useNavigation(listRef)

    const tabs = [{ // eslint-disable-line
        key: 'user',
        category: 'users',
        name: 'Сотрудники'
    }, {
        key: 'direction',
        category: 'users',
        name: 'Направления'
    }, {
        key: 'department',
        category: 'users',
        name: 'Отделы'
    }]
    const match = useRouteMatch<{ key: RefKey }>(ROUTES.SETTINGS_REF)
    const selected = useMemo(() => tabs.find(tab => tab.key === match?.params.key), [match?.params?.key, tabs])

    return <div className={refStyles.refPage}>
        <div className={styles.headerMenu}>
            <Tabs
                items={tabs}
                itemToKey={tab => tab.key}
                selected={selected}
                renderer={tab => <NavLink
                    key={tab.key}
                    to={urlWithParams({key: tab.key})(ROUTES.SETTINGS_REF)}
                >
                    {tab.name}
                </NavLink>}
            />

        </div>
        <div className={refStyles.header}>
            <Field placeholder={'Поиск'} rightItem={<SearchIcon/>} value={search} onChange={setSearch}/>
        </div>
        <InfiniteScroll ref={listRef} className={refStyles.body} onReach={() => dispatch(usersActions.list.more())}>
            <Table<UserWithDepartments>
                className={refStyles.table}
                data={data}
                rowClass={user => clsx({[Classes.tLineThrough]: user.is_blocked})}
            >
                <Column<UserWithDepartments> headerRenderer={'Имя'} cellRenderer={user => user.name}/>
                <Column<User> headerRenderer={'Описание'} cellRenderer={user => user.description}/>
                <Column<UserWithDepartments>
                    headerRenderer={'Отделы'}
                    cellRenderer={user => user.departments.map(dep => dep.title).join(',')}
                />
                <Column<User> headerRenderer={'Активность'} cellRenderer={user => <Checkbox
                    disabled={user.is_blocked}
                    value={user.active && !user.is_blocked}
                    onChange={active => dispatch(usersActions.update.request({
                        id: user.id,
                        active,
                    }))}
                />}/>
            </Table>
        </InfiniteScroll>
    </div>
}

export default UsersPage